import React from 'react';
import PropTypes from 'prop-types';
import '../stylesheets/components/MetricsCards.css';

const MetricsCards = ({ metricsData, selectedDateOption, dateRange }) => {
  const getSubtitleText = () => {
    if (selectedDateOption === 'dateRange' && dateRange.startDate && dateRange.endDate) {
      const startDate = new Date(dateRange.startDate).toLocaleDateString('en-US', { 
        month: 'short', day: 'numeric', year: 'numeric' 
      });
      const endDate = new Date(dateRange.endDate).toLocaleDateString('en-US', { 
        month: 'short', day: 'numeric', year: 'numeric' 
      });
      return `${startDate} - ${endDate}`;
    }
    return 'All Time';
  };

  const cardData = [
    {
      title: "Signed Up Users",
      value: metricsData !== null ? metricsData?.numberOfActiveUsers : 0,
      subtitle: getSubtitleText(),
      color: "green"
    },
    {
      title: "Number of Conversations",
      value: metricsData !== null ? metricsData?.overallNumberOfConversationsCreated : 0,
      subtitle: getSubtitleText(),
      color: "green"
    },
    {
      title: "Avg. No Conversation Per Manager",
      value: metricsData !== null ? metricsData?.averageNumberOfConversationsPerManager : 0,
      subtitle: getSubtitleText(),
      color: "green"
    },
    {
      title: "Avg. No Conversations Between Pair",
      value: metricsData !== null ? metricsData?.averageNumberOfConversationsPerPair : 0,
      subtitle: getSubtitleText(),
      color: "green"
    },
    {
      title: "Percentage that Shared Info with Manager",
      value: metricsData !== null && metricsData?.frequencyOfInformationSharedWithManagerPct >= 0 
        ? `${metricsData?.frequencyOfInformationSharedWithManagerPct}%` : `0%`,
      subtitle: getSubtitleText(),
      color: "green"
    },
    {
      title: "Avg. No of Topics Discussed Per Con.",
      value: metricsData !== null && metricsData?.averageNumberOfTopicsPerConversation >= 0 ? 
        metricsData?.averageNumberOfTopicsPerConversation : 0,
      subtitle: getSubtitleText(),
      color: "green"
    },
    {
      title: "Avg. No of Controls Per Topic per Conversation",
      value: metricsData !== null && metricsData?.averageDetailsPerConversationTopic.averageNumberOfControlsPerTopic >= 0 ? 
        metricsData?.averageDetailsPerConversationTopic.averageNumberOfControlsPerTopic : 0,
      subtitle: getSubtitleText(),
      color: "green"
    },
    {
      title: "Avg. No of Actions Per Topic per Conversation",
      value: metricsData !== null && metricsData?.averageDetailsPerConversationTopic.averageNumberOfActionsPerTopic >= 0 ? 
        metricsData?.averageDetailsPerConversationTopic.averageNumberOfActionsPerTopic : 0,
      subtitle: getSubtitleText(),
      color: "green"
    },
    {
      title: "No of Actions Marked Completed",
      value: metricsData !== null && metricsData?.totalNumberOfActionsMarkedComplete >= 0 ? 
        metricsData?.totalNumberOfActionsMarkedComplete : 0,
      subtitle: getSubtitleText(),
      color: "green"
    }
  ];

  return (
    <div className="metrics-container">
      <div className="metrics-grid">        {cardData.map((card) => (
          <div key={card.title} className="metric-card">
            <h3 className="metric-title">{card.title}</h3>
            <div className={`metric-value ${card.color}`}>
              {card.value}
            </div>
            <p className="metric-subtitle">{card.subtitle}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

MetricsCards.propTypes = {
  metricsData: PropTypes.shape({
    numberOfActiveUsers: PropTypes.number,
    overallNumberOfConversationsCreated: PropTypes.number,
    averageNumberOfConversationsPerManager: PropTypes.number,
    averageNumberOfConversationsPerPair: PropTypes.number,
    frequencyOfInformationSharedWithManagerPct: PropTypes.number,
    averageNumberOfTopicsPerConversation: PropTypes.number,
    averageDetailsPerConversationTopic: PropTypes.shape({
      averageNumberOfControlsPerTopic: PropTypes.number,
      averageNumberOfActionsPerTopic: PropTypes.number,
    }),
    totalNumberOfActionsMarkedComplete: PropTypes.number,
  }),
  selectedDateOption: PropTypes.string.isRequired,
  dateRange: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
};

export default MetricsCards;
